// Google アナリティクス（GA4）。LP（site.nitte.app）と同じプロパティ
// 「ニッテLPとWebアプリ - GA4」に送り、LP から登録・利用までを一続きで見られるようにする。
// 計測IDは本番の .env.production にだけ置く。staging やローカルでは何も送らない。
const measurementId = import.meta.env.VITE_APP_GA_MEASUREMENT_ID as
  | string
  | undefined

declare global {
  interface Window {
    dataLayer: unknown[]
    gtag: (...args: unknown[]) => void
  }
}

let initialized = false

const init = (uid: string | null) => {
  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    // gtag.js は arguments オブジェクトのまま積まれたものしか解釈しない
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', measurementId, uid ? { user_id: uid } : {})

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
  document.head.appendChild(script)
}

/**
 * 認証状態が決まるたびに呼ぶ。初回は gtag.js を読み込んで、そのときのユーザーで計測を始める。
 * 以降のログイン・ログアウトは set で user_id だけ差し替える（GA の公式手順どおり）。
 */
export const updateAnalyticsUser = (uid: string | null) => {
  if (!measurementId) {
    return
  }
  if (!initialized) {
    initialized = true
    init(uid)
    return
  }
  window.gtag('set', { user_id: uid })
}
